import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import UserMenu from './UserMenu';
import Sidebar from './Sidebar';
import Box from './Box';
import Toast from './Toast';
import Tools from './Tools';
import ModalWindow from './ModalWindow';
import axios from 'axios';

import AdminCompany from './admin/AdminCompany';
import AdminContactType from './admin/AdminContactType';
import AdminTaskType from './admin/AdminTaskType';
import AdminTaskField from './admin/AdminTaskField';

import './css/Home.css';

import { ReactComponent as PlusIcon } from './icons/plus.svg';
import { ReactComponent as DashIcon } from './icons/dash.svg';

import PlusCircle from './icons/PlusCircle';
import IconTrash from './icons/Trash';
import IconEdit from './icons/Edit3';

import { Fragment } from 'react';



const VariableFields = (props) => {
    const [sessionData, setSessionData] = useState({}); 
    const [error, setError] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [currentSelectedCompanyDescription, setCurrentSelectedCompanyDescription] = useState(null);
    const [currentSelectedContactTypeDescription, setCurrentSelectedContactTypeDescription] = useState(null);
    const [currentSelectedTaskTypeDescription, setCurrentSelectedTaskTypeDescription] = useState(null);
    const [toastRef, setToastRef] = useState(React.createRef());
    const [contactTypes, setContactTypes] = useState([]);
    const [taskTypes, setTaskTypes] = useState([]); 
    const [taskFields, setTaskFields] = useState([]); 
    const [formData, setFormData] = useState({ 
        company: '', contactType: '', taskType: null, 
        newCompanyName: '', newContactTypeName: '', newTaskTypeName: '', newTaskFieldName: '', newTaskFieldType:'',
        newTaskFieldLabel: '', newTaskFieldLength: 0, newTaskFieldPosition: 0, newTaskFieldList: '' }); 

    const [currentAdmin, showCurrentAdmin] = useState(null); 
    const [currentAdminMethod, setCurrentAdminMethod] = useState(null);
    

    const history = useHistory();


    const setCurrentAdmin = (entity, method) =>{
        showCurrentAdmin(entity);
        setCurrentAdminMethod(method);
    }

    useEffect(() => {
        if (!sessionStorage.getItem('sessionData')) {
            history.push('/login');
        } else {
            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
            getCompanys();
        }
    }, []);

    const getCompanys=()=>{
        //get companies
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/companies`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: {}
        };
        axios(options).then(response => {
            setCompanies(response.data);
        })
        .catch(function (error) {
            console.log("Error:", error.message);
            setError(error.message);
        });
    }

    
    const refreshCurrentListOfFields = () => {
        getTaskFields(formData.taskType);
        showCurrentAdmin(null); //close admin window
        toastRef.current.addToast('Una campo de gestión ha sido ingresado', 5000);
    }

    const getTaskFields = (taskType) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));

        let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/taskFields`);
        url.search = new URLSearchParams({
            taskTypeId: taskType,
        });

        fetch(url, {
            method: 'GET',
            contentType: 'application/json',
            headers: { 'Authorization': currentSessionData.token }
        })
            .then(res => {
                if (res.status === 401) { Tools.logout(history); }
                return res.json();
            })
            .then(
                (result) => {
                    setTaskFields(result);
                },
                (error) => {
                    console.log('Se produjo un errrooooor:', error);
                    setError(error);
                }
            )
    }

    const getTaskTypes = (contactType) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));

        let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/taskTypes`);
        url.search = new URLSearchParams({
            contactTypeId: contactType,
        });

        fetch(url, {
            method: 'GET',
            contentType: 'application/json',
            headers: { 'Authorization': currentSessionData.token }
        })
            .then(res => {
                if (res.status === 401) { Tools.logout(history); }
                return res.json();
            })
            .then(
                (result) => {
                    setTaskTypes(result);
                },
                (error) => {
                    console.log('Se produjo un errrooooor:', error);
                    setError(error);
                }

                
            )
    }

    const getContactTypesForCompany = (event, companyId=null) => {

        let currentCompany=null;
        if(event){
            handleInputChange(event);
            currentCompany = event.target.value;
        }else{
            currentCompany = companyId;
        }

        //let currentSelectedCompany = Tools.findElementByKey(companies, 'company_id', currentCompany);
        //setCurrentSelectedCompanyDescription(currentSelectedCompany.company_name);

        //contactTypes
        fetch(`${process.env.REACT_APP_URI_API_CRM}/contactTypes?idCompany=${currentCompany}`)
        .then(res => {
            if (res.status === 401) { Tools.logout(history); }
            return res.json();
        })
        .then(
            (result) => {
                setContactTypes(result);
                setTaskTypes([]); 
                setTaskFields([]);
            },
            (error) => {
                setError(error);
            }
        )
    }

    const getTaskTypesForContactType = (event, contactTypeId=null) => {
        formData.taskType=''; //hack reset selectbox

        let currentContactType = null;
        if (event) {
            handleInputChange(event);
            currentContactType = event.target.value;
        } else {
            currentContactType = contactTypeId;
        }

        //let currentSelectedContactType = Tools.findElementByKey(contactTypes, 'contact_type_id', currentContactType);
        //setCurrentSelectedContactTypeDescription(currentSelectedContactType.desc);

        
        getTaskTypes(currentContactType);
        setTaskFields([]);
    }

    const getTaskFieldsForTaskTypes = (event) => {
        handleInputChange(event);
        getTaskFields(event.target.value);

        //let currentSelectedTaskType = Tools.findElementByKey(taskTypes, 'task_type_id', event.target.value);
        //setCurrentSelectedTaskTypeDescription(currentSelectedTaskType.desc);
    }

    const notifyChangeCompanys =()=>{
        getCompanys();
        showCurrentAdmin(null); 

        //reset select and reset descendents lists
        setFormData({ ...formData, ['company']: "" });
        setTaskTypes([]);
        setTaskFields([]);

        toastRef.current.addToast('La lista de empresas se ha modificado', 5000);
    }

    
    const notifyChangeContactTypes =()=>{
        getContactTypesForCompany(null, formData.company);
        showCurrentAdmin(null); 

        //reset select and reset descendents lists
        setFormData({ ...formData, ['contactType']: "" });
        setTaskTypes([]);
        setTaskFields([]);

        toastRef.current.addToast('La lista de tipos de contacto se ha modificado', 5000);
    }

    const notifyChangeTaskTypes =()=>{
        getTaskTypesForContactType(null, formData.contactType);
        showCurrentAdmin(null); 

        //reset select and reset descendents lists
        setFormData({ ...formData, ['taskType']: "" });
        setTaskFields([]);

        toastRef.current.addToast('La lista de tipos de gestión se ha modificado', 5000);
    }



    const handleInputChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value })
    }


    return (
        <div className="mainWrapper">
            <Toast ref={toastRef}></Toast>
            <Sidebar key={props.inboundConnectedQueues} />
            {currentAdmin!==null ? (
                <ModalWindow closeMethod={() => showCurrentAdmin(null)}>
                    {currentAdmin === 'COMPANY' ? (<AdminCompany method={currentAdminMethod} currentSelected={{ id: formData.company, desc: currentSelectedCompanyDescription }} methodToRefreshList={notifyChangeCompanys}/> ): null}
                    {currentAdmin === 'CONTACT_TYPE' ? (<AdminContactType method={currentAdminMethod} dependentData={{ id: formData.contactType, desc: currentSelectedContactTypeDescription, idCompany: formData.company }} methodToRefreshList={ notifyChangeContactTypes}/>) : null}
                    {currentAdmin === 'TASK_TYPE' ? (<AdminTaskType method={currentAdminMethod} dependentData={{ id: formData.taskType, desc: currentSelectedTaskTypeDescription, idContactType: formData.contactType }} methodToRefreshList={ notifyChangeTaskTypes}/> ) : null}
                    
                    {currentAdmin === 'TASK_FIELD' ? (<AdminTaskField method={currentAdminMethod} parentTaskType={formData.taskType} parentMethodToExecuteAfterEdit={refreshCurrentListOfFields} listOfAllTaskFields={taskFields}/>) : null}
                </ModalWindow>
            ) : null}

            <div className="main">
                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1>Configuración árbol gestión</h1>
                        <span className="upper">Edición de Tipos de Contacto, tipos de gestión y campos de gestión</span>
                    </div>
                    <div className="flexWrapper"> 
                        <UserMenu />
                    </div>
                </div>

                <form id="frmNewTaskField" noValidate>
                    <div className="flexRow">
                        <div className="flexCol">
                            <Box type="select" value={formData.company}     name="company"     label="Cliente (empresa)" className="x2" placeholder="Seleccione ..." options={companies}    onChange={getContactTypesForCompany}  entityToAdmin="COMPANY"      adminMenuMethod={setCurrentAdmin} required></Box>
                            <Box type="select" value={formData.contactType} name="contactType" label="Tipo de contacto"  className="x2" placeholder="Seleccione ..." options={contactTypes} onChange={getTaskTypesForContactType} entityToAdmin="CONTACT_TYPE" adminMenuMethod={setCurrentAdmin} required></Box>
                            <Box type="select" value={formData.taskType}    name="taskType"    label="Gestión"           className="x2" placeholder="Seleccione ..." options={taskTypes}    onChange={getTaskFieldsForTaskTypes}  entityToAdmin="TASK_TYPE"    adminMenuMethod={setCurrentAdmin} required></Box>
                        </div>  
                    </div>  
                </form>

                <h2 className="subTitle">Campos gestión asociados</h2>

                <table>
                    <thead>
                        <tr>
                            <th>Tipo campo</th>
                            <th>Nombre</th>
                            <th>Etiqueta</th>
                            <th>Largo</th>
                            <th>Lista asociada</th>
                            <th align="right">Posición</th>
                            <th>
                                {formData.taskType ? (
                                    <a onClick={() => showCurrentAdmin('TASK_FIELD')}><PlusCircle /></a>
                                ) : null}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {taskFields.map((listValue, index) => {
                            return (
                                <tr key={index}>
                                    <td>{listValue.type}</td>
                                    <td>{listValue.name}</td>
                                    <td>{listValue.desc}</td>
                                    <td align={listValue.length ? null : 'center'}>{(listValue.length) ? listValue.length : <DashIcon/>}</td>
                                    <td align={listValue.nameItemList ? null : 'center'}>{(listValue.nameItemList) ? listValue.nameItemList : <DashIcon />}</td>
                                    <td align="right">{listValue.position}</td>
                                    <td className="menus">
                                        <a onClick={() => console.log('delete')}><IconTrash /></a>
                                        <a onClick={() => console.log('edit')}><IconEdit /></a>
                                        </td>
                                </tr>
                                
                            );
                        })}  
                    </tbody>
                </table>  

            
            </div>
        </div>
    );
}

export default VariableFields;